// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3QEeC","modalForm":"UpgradeEpcsModal_modalForm__1BzeQ","modalFooter":"UpgradeEpcsModal_modalFooter__16opI"};